import { useMemo } from 'react';

import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { formatContractTypeLabel } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/utils/formatContractTypeLabel.ts';
import { formatEnumValue } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/utils/formatEnumValue.ts';
import { formatApplicabilityLabel } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/utils/formatApplicabilityLabel.ts';
import {
	ContractType,
	SignatureType,
	InvestmentWorkflowType,
} from '@dealstack/shared/lib/generated';

interface SelectOption {
	value: string;
	label: string;
}

export const useContractOptions = (tMipManage: ReturnType<typeof useTranslationMipManage>) => {
	const contractTypeOptions: SelectOption[] = useMemo(
		() =>
			Object.values(ContractType).map((type) => ({
				value: type,
				label: formatContractTypeLabel(type, tMipManage),
			})),
		[tMipManage]
	);

	const signatureTypeOptions: SelectOption[] = useMemo(
		() =>
			Object.values(SignatureType).map((type) => ({
				value: type,
				label: formatEnumValue(type),
			})),
		[]
	);

	const applicabilityOptions: SelectOption[] = useMemo(
		() =>
			Object.values(InvestmentWorkflowType).map((type) => ({
				value: type,
				label: formatApplicabilityLabel(type, tMipManage),
			})),
		[tMipManage]
	);

	return { contractTypeOptions, signatureTypeOptions, applicabilityOptions };
};
